// External Dependencies
import AddIcon from '@mui/icons-material/Add';
import Button, { type ButtonProps } from '@mui/material/Button';

// Local Typings
export interface AddButtonProps extends ButtonProps {
  disabled?: boolean;
  label: string;
  marginRight?: number;
}

// Component Definition
const AddButton = ({
  label,
  marginRight,
  ...otherProps
}: AddButtonProps): JSX.Element => {
  return (
    <Button
      color="primary"
      size="small"
      startIcon={<AddIcon fontSize="small" />}
      sx={{ marginRight }}
      variant="outlined"
      {...otherProps}
    >
      {label}
    </Button>
  );
};

export default AddButton;
